module.exports = __webpack_public_path__ + "static/img/logo - 副本.da949ec1.png";